import { z } from 'zod';

export const createEvaluationSessionSchema = z.object({
  patient_id: z.string().min(1, 'Patient ID is required'),
  module_id: z.string().min(1, 'Module ID is required'),
});

export type CreateEvaluationSessionPayload = z.infer<typeof createEvaluationSessionSchema>;
